// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/app.scss
// module id = 197
// module chunks = 0